import { Patients } from "cadendar-shared";
import styles from "./PatientEtatCivilDisplay.module.css";
import { formaters } from "vincent-utils";

type PatientDisplay = Omit<Patients, "patient_portal_key">;

interface PatientEtatCivilDisplayProps {
  patient: PatientDisplay;
}

const PatientEtatCivilDisplay = (props: PatientEtatCivilDisplayProps) => {
  const { patient } = props;
  return (
    <div className={styles.panel}>
      <div className={styles.label}>Nom :</div>
      <div className={styles.input}>
        {formaters.capitaliseEveryFirstLetter(patient.name)}
      </div>
      <div className={styles.label}>Prénom :</div>
      <div className={styles.input}>
        {formaters.capitaliseEveryFirstLetter(patient.forename)}
      </div>
      <div className={styles.label}>Date de naissance :</div>
      <div className={styles.input}>{patient.birthdate}</div>
      <div className={styles.label}>Fixe :</div>
      <div className={styles.label}>Portable :</div>
      <div className={styles.input}>{patient.portablee164}</div>
      <div className={styles.label}>Email :</div>
      <div className={styles.input}>{patient.email}</div>
      <div className={styles.label}>Commentaires :</div>
      <div className={styles.input}>{patient.comments || ""}</div>
    </div>
  );
};

export default PatientEtatCivilDisplay;
